import { apiRequest } from './api';

const LIMITS = {
  image: 12 * 1024 * 1024,
  video: 100 * 1024 * 1024,
  raw: 15 * 1024 * 1024,
};

const ALLOWED_TYPES = {
  image: new Set(['image/jpeg', 'image/png', 'image/webp', 'image/avif', 'image/heic', 'image/heif']),
  video: new Set(['video/mp4', 'video/webm', 'video/quicktime']),
  raw: new Set(['application/pdf']),
};

function validateFile(file, resourceType) {
  if (!file || !(file instanceof Blob)) throw new Error('Seleccioná un archivo válido');
  if (!ALLOWED_TYPES[resourceType].has(file.type)) {
    throw new Error(resourceType === 'image'
      ? 'Usá una imagen JPG, PNG, WebP, AVIF o HEIC'
      : resourceType === 'video' ? 'Usá un video MP4, WebM o MOV' : 'Usá un archivo PDF');
  }
  if (!file.size || file.size > LIMITS[resourceType]) {
    throw new Error(resourceType === 'image'
      ? 'La imagen no puede superar 12 MB'
      : resourceType === 'video' ? 'El video no puede superar 100 MB' : 'El PDF no puede superar 15 MB');
  }
}

async function signedUpload(file, resourceType) {
  validateFile(file, resourceType);
  const authorization = await apiRequest('/uploads/authorize', {
    method:'POST',
    body:{ resourceType, mimeType:file.type, size:file.size },
  });
  const formData = new FormData();
  formData.append('file', file);
  formData.append('api_key', authorization.apiKey);
  formData.append('timestamp', String(authorization.timestamp));
  formData.append('folder', authorization.folder);
  formData.append('signature', authorization.signature);

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${encodeURIComponent(authorization.cloudName)}/${resourceType}/upload`,
    { method:'POST', body:formData },
  );
  if (!response.ok) throw new Error('No pudimos subir el archivo. Intentá nuevamente.');
  return response.json();
}

export async function uploadImage(file) {
  const data = await signedUpload(file, 'image');
  if (!data.secure_url) throw new Error('Cloudinary no devolvió la imagen subida');
  return data.secure_url;
}

export async function uploadVideo(file) {
  const data = await signedUpload(file, 'video');
  if (!data.secure_url) throw new Error('Cloudinary no devolvió el video subido');
  return {
    url:data.secure_url,
    duration:Number(data.duration) || 0,
    poster:data.secure_url.replace(/\.[^.]+$/, '.jpg'),
  };
}

export async function uploadDocument(file) {
  const data = await signedUpload(file, 'raw');
  if (!data.secure_url) throw new Error('Cloudinary no devolvió el plano subido');
  return data.secure_url;
}
